import { useMemo } from 'react';

import { useCluster } from '@cast/shared-cluster-context-data-access';
import {
  isClusterDiscovered,
  isClusterWithOldK8s,
  isDisconnectedForMonth,
  isStorageReportsSupported,
  shouldShowAgentInstallBanner,
  shouldShowReconcileInfo,
} from '@cast/features-cluster-shared-utils';
import { isDemoCluster } from '@cast/utils';

export const useClusterDashboardState = () => {
  const clusterContext = useCluster();
  const { cluster } = clusterContext;

  return useMemo(
    () => ({
      ...clusterContext,
      isInaccessible: isDisconnectedForMonth(cluster),
      isDiscovered: isClusterDiscovered(cluster),
      showStorage: isStorageReportsSupported(cluster),
      showAgentInstallBanner: shouldShowAgentInstallBanner(
        cluster,
        clusterContext
      ),
      showReconcileInfo: shouldShowReconcileInfo(
        cluster,
        clusterContext.isManaged
      ),
      hasOldK8s: isClusterWithOldK8s(cluster, clusterContext.isManaged),
      showProviderNamespace: Boolean(cluster.providerNamespaceId),
      isDemoCluster: isDemoCluster(cluster.id),
      showOperationalMetrics: clusterContext.isOnline,
    }),
    [cluster, clusterContext]
  );
};
